export const formatTelNo = tel => tel.replace(/\s/g, '');
